import { Cache } from '@urql/exchange-graphcache';

import { GQGetMaterialVariantsQuery } from '../../generated/graphql-operations';
import { GetMaterialVariantsDocument } from '../../generated/urql';

export function updateMaterialVariantsRunProgressCache(
  cache: Cache,
  runningCount: number,
  runType: 'flash' | 'proxyMapping'
): void {
  cache.updateQuery(
    { query: GetMaterialVariantsDocument },
    (data: GQGetMaterialVariantsQuery | null) => {
      return updateMaterialVariantsRunProgress(data, runningCount, runType);
    }
  );
}

export function updateMaterialVariantsRunProgress(
  data: GQGetMaterialVariantsQuery | null,
  runningCount: number,
  runType: 'flash' | 'proxyMapping'
): GQGetMaterialVariantsQuery | null {
  if (!data) {
    return null;
  }

  // Create a deep copy to avoid mutating the original data
  const updatedData = JSON.parse(
    JSON.stringify(data)
  ) as GQGetMaterialVariantsQuery;

  updatedData.materialVariantsRunProgress.runningCount += runningCount;
  // When polling starts we will fetch the estimated time remaining from the server
  updatedData.materialVariantsRunProgress.estimatedTimeRemainingMinutes = null;

  if (runType === 'flash') {
    updatedData.productFootprintUsageAndLimits.flash.inProgressRuns +=
      runningCount;
  } else {
    updatedData.productFootprintUsageAndLimits.proxyMapping.inProgressRuns +=
      runningCount;
  }

  return updatedData;
}
